import { render } from "./NavbarAdmin.vue?vue&type=template&id=0fcfd833&scoped=true"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js"

import "./NavbarAdmin.vue?vue&type=style&index=0&id=0fcfd833&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcfd833"]])

export default __exports__